import { initGraphQLTada } from 'gql.tada';
// @ts-ignore generated code
import type { introspection } from './graphql-env';

export const graphql = initGraphQLTada<{
  disableMasking: true;
  introspection: introspection;
  scalars: {
    JSON: any;
    URL: string;
    NPS: number;
    Timestamp: number;
    TimestampRange: number[];
    Date: string;
    DateRange: string[];
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { readFragment } from 'gql.tada';
